import { API_BASE_URL } from './config';
import { getAuthHeaders } from './utils';

export const ordersAPI = {
    async create(order) {
        const res = await fetch(`${API_BASE_URL}/orders`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(order)
        });
        if (!res.ok) throw new Error('Failed to create order');
        return res.json();
    },
    async adminList(params = {}) {
        const query = new URLSearchParams(params).toString();
        const res = await fetch(`${API_BASE_URL}/orders${query ? `?${query}` : ''}`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error('Failed to fetch orders');
        return res.json();
    },
    async get(id) {
        const res = await fetch(`${API_BASE_URL}/orders/${id}`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error('Order not found');
        return res.json();
    },
    async update(id, data) {
        const res = await fetch(`${API_BASE_URL}/orders/${id}`, {
            method: 'PUT',
            headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error('Failed to update order');
        return res.json();
    },
    invoiceUrl(id) {
        return `${API_BASE_URL}/orders/${id}/invoice`;
    }
};





